export enum OrderType {
  client = 1,
  simplified = 2,
  All = client | simplified
}
